// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1evQL","savePackageButton":"ClientWallet_savePackageButton___zAtq"};